import React, { useState } from 'react';
import '../../styles/PaymentInstructions.css';

/**
 * PaymentInstructions - Bank transfer payment instructions (Phase 1)
 *
 * Props:
 * - total: Total amount to pay
 * - currency: Currency code (default 'SAR')
 * - confirmationCode: Booking confirmation code (for reference)
 */
const PaymentInstructions = ({ total, currency = 'SAR', confirmationCode }) => {
  const [copied, setCopied] = useState(false);

  // Host Me bank account details (Phase 1 - Manual transfer)
  const bankDetails = {
    bankName: 'البنك الأهلي السعودي',
    bankNameEn: 'Al Ahli Bank',
    accountName: 'Host Me لإدارة العقارات',
    accountNumber: 'SA1234567890123456789012',
    iban: 'SA1234567890123456789012',
    swiftCode: 'NCBKSAJE'
  };

  const handleCopyIBAN = () => {
    navigator.clipboard.writeText(bankDetails.iban);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="payment-instructions">
      <div className="payment-header">
        <i className="bi bi-bank"></i>
        <h3>تعليمات الدفع - التحويل البنكي</h3>
      </div>

      {/* Payment Amount */}
      <div className="payment-amount-box">
        <span className="amount-label">المبلغ المطلوب:</span>
        <div className="amount-display">
          <span className="amount-value">{total}</span>
          <span className="amount-currency">{currency === 'SAR' ? 'ريال' : currency}</span>
        </div>
      </div>

      {/* Bank Details */}
      <div className="bank-details-card">
        <div className="bank-detail-row">
          <span className="detail-label">اسم البنك:</span>
          <span className="detail-value">{bankDetails.bankName}</span>
        </div>

        <div className="bank-detail-row">
          <span className="detail-label">اسم الحساب:</span>
          <span className="detail-value">{bankDetails.accountName}</span>
        </div>

        <div className="bank-detail-row highlighted">
          <span className="detail-label">رقم الآيبان (IBAN):</span>
          <div className="iban-container">
            <span className="detail-value iban-value">{bankDetails.iban}</span>
            <button
              onClick={handleCopyIBAN}
              className="copy-btn"
              title="نسخ رقم الآيبان"
            >
              <i className={`bi ${copied ? 'bi-check-circle-fill' : 'bi-clipboard'}`}></i>
              {copied ? 'تم النسخ' : 'نسخ'}
            </button>
          </div>
        </div>
      </div>

      {/* Important Instructions */}
      <div className="instructions-box">
        <h4 className="instructions-title">
          <i className="bi bi-exclamation-circle"></i>
          تعليمات هامة
        </h4>
        <ul className="instructions-list">
          <li>
            <strong>يجب كتابة رمز الحجز في حقل الملاحظات:</strong>
            <code className="confirmation-code">{confirmationCode}</code>
          </li>
          <li>
            يُرجى إرسال إشعار التحويل البنكي إلى البريد الإلكتروني:
            <a href="mailto:payments@hostme.sa" className="email-link">payments@hostme.sa</a>
          </li>
          <li>
            سيتم تأكيد الحجز خلال 24 ساعة من استلام المبلغ
          </li>
          <li>
            يُرجى الاحتفاظ بإيصال التحويل البنكي كإثبات للدفع
          </li>
        </ul>
      </div>

      {/* Timeline */}
      <div className="payment-timeline">
        <div className="timeline-item">
          <div className="timeline-icon">1</div>
          <div className="timeline-content">
            <h5>قم بالتحويل البنكي</h5>
            <p>استخدم رقم الآيبان أعلاه</p>
          </div>
        </div>

        <div className="timeline-connector"></div>

        <div className="timeline-item">
          <div className="timeline-icon">2</div>
          <div className="timeline-content">
            <h5>أرسل إشعار التحويل</h5>
            <p>إلى payments@hostme.sa مع رمز الحجز</p>
          </div>
        </div>

        <div className="timeline-connector"></div>

        <div className="timeline-item">
          <div className="timeline-icon">3</div>
          <div className="timeline-content">
            <h5>تأكيد الحجز</h5>
            <p>خلال 24 ساعة عبر البريد الإلكتروني</p>
          </div>
        </div>
      </div>

      {/* Support Contact */}
      <div className="support-box">
        <i className="bi bi-headset"></i>
        <div>
          <strong>تحتاج مساعدة؟</strong>
          <p>اتصل بنا على: <a href="tel:+966501234567" className="phone-link" dir="ltr">+966 50 123 4567</a></p>
        </div>
      </div>
    </div>
  );
};

export default PaymentInstructions;
